var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
// TODO: add background color to tokens. This color specifically with the opacity.
export var ModalWrapper = styled.div.attrs(function (_a) {
    var zIndex = _a.zIndex;
    return ({
        zIndex: zIndex,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var zIndex = props.zIndex;
    return "\n      overflow: scroll;\n      position: fixed;\n      height: 100%;\n      width: 100%;\n      z-index: " + zIndex + ";\n      margin: 0px;\n      padding: 0px;\n      background-color: rgb(4, 30, 65, 74%);\n\n      top: 50%;\n      left: 50%;\n      -webkit-transform: translate(-50%, -50%);\n      -moz-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%);\n    ";
});
var templateObject_1;
//# sourceMappingURL=modal.variant.shared.js.map